import { render, staticRenderFns } from "./Tab3.vue?vue&type=template&id=47ee389a&scoped=true"
import script from "./Tab3.vue?vue&type=script&lang=js"
export * from "./Tab3.vue?vue&type=script&lang=js"
import style0 from "./Tab3.vue?vue&type=style&index=0&id=47ee389a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ee389a",
  null
  
)

export default component.exports